var _g, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisitWhiteFang(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 96,
    viewBox: "0 0 136 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7454_55404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34 39H102V72C102 75.3137 99.3137 78 96 78H40C36.6863 78 34 75.3137 34 72V39Z",
    fill: "#DEF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.038 34.864H34.0001V37.3617H102.038V34.864Z",
    fill: "#E8F2F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.9945 22.8566H38.7463H38.2189C37.1087 22.8566 36.017 23.3099 35.2306 24.0962C34.4534 24.8825 34.0001 25.9648 34.0001 27.0749V31.9778H102.038V27.0749C102.038 25.9648 101.585 24.8825 100.799 24.0962C100.012 23.3099 98.9297 22.8566 97.8195 22.8566H90.6585V28.3792C90.6585 29.4061 89.8259 30.2479 88.7897 30.2479H84.8576C83.8307 30.2479 82.9887 29.4153 82.9887 28.3792V22.8566H53.0497V28.3792C53.0497 29.4061 52.217 30.2479 51.1808 30.2479H47.2487C46.2125 30.2479 45.3799 29.4153 45.3799 28.3792V22.8566H40.9945Z",
    fill: "#4A6F93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.038 31.9778H34.0001V34.864H102.038V31.9778Z",
    fill: "#BAD4DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2487 26.4133C47.2487 27.4991 48.129 28.3793 49.2148 28.3793C50.3006 28.3793 51.1808 27.4991 51.1808 26.4133V22.8566V19.966C51.1808 18.8802 50.3006 18 49.2148 18C48.129 18 47.2487 18.8802 47.2487 19.966V22.8566V26.4133Z",
    fill: "#DEF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8576 26.4086C84.8576 27.497 85.7399 28.3793 86.8283 28.3793C87.9166 28.3793 88.7989 27.497 88.7989 26.4086V22.8566V19.9706C88.7989 18.8823 87.9166 18 86.8283 18C85.7399 18 84.8576 18.8823 84.8576 19.9706V22.8566V26.4086Z",
    fill: "#DEF0F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2939 41.7188H54.5517C52.3425 41.7188 50.5517 43.5096 50.5517 45.7187V46.3867C50.5517 48.5958 52.3425 50.3867 54.5517 50.3867H56.2939C58.503 50.3867 60.2939 48.5958 60.2939 46.3867V45.7188C60.2939 43.5096 58.503 41.7188 56.2939 41.7188Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8949 41.7188H67.1527C64.9435 41.7188 63.1527 43.5096 63.1527 45.7187V46.3867C63.1527 48.5958 64.9435 50.3867 67.1527 50.3867H68.8949C71.104 50.3867 72.8949 48.5958 72.8949 46.3867V45.7188C72.8949 43.5096 71.104 41.7188 68.8949 41.7188Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4868 41.7188H79.7445C77.5354 41.7188 75.7445 43.5096 75.7445 45.7187V46.3867C75.7445 48.5958 77.5354 50.3867 79.7445 50.3867H81.4868C83.6959 50.3867 85.4868 48.5958 85.4868 46.3867V45.7188C85.4868 43.5096 83.6959 41.7188 81.4868 41.7188Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0878 41.7188H92.3455C90.1364 41.7188 88.3456 43.5096 88.3456 45.7187V46.3867C88.3456 48.5958 90.1364 50.3867 92.3456 50.3867H94.0878C96.2969 50.3867 98.0878 48.5958 98.0878 46.3867V45.7188C98.0878 43.5096 96.2969 41.7188 94.0878 41.7188Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7021 52.7826H41.9598C39.7507 52.7826 37.9598 54.5735 37.9598 56.7826V57.4412C37.9598 59.6504 39.7507 61.4412 41.9598 61.4412H43.7021C45.9112 61.4412 47.7021 59.6504 47.7021 57.4412V56.7826C47.7021 54.5735 45.9112 52.7826 43.7021 52.7826Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2939 52.7826H54.5517C52.3425 52.7826 50.5517 54.5735 50.5517 56.7826V57.4412C50.5517 59.6504 52.3425 61.4412 54.5517 61.4412H56.2939C58.503 61.4412 60.2939 59.6504 60.2939 57.4412V56.7826C60.2939 54.5735 58.503 52.7826 56.2939 52.7826Z",
    fill: "#204568"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8949 52.7826H67.1527C64.9435 52.7826 63.1527 54.5735 63.1527 56.7826V57.4412C63.1527 59.6504 64.9435 61.4412 67.1527 61.4412H68.8949C71.104 61.4412 72.8949 59.6504 72.8949 57.4412V56.7826C72.8949 54.5735 71.104 52.7826 68.8949 52.7826Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4868 52.7826H79.7445C77.5354 52.7826 75.7445 54.5735 75.7445 56.7826V57.4412C75.7445 59.6504 77.5354 61.4412 79.7445 61.4412H81.4868C83.6959 61.4412 85.4868 59.6504 85.4868 57.4412V56.7826C85.4868 54.5735 83.6959 52.7826 81.4868 52.7826Z",
    fill: "#E9F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0878 52.7826H92.3455C90.1364 52.7826 88.3456 54.5735 88.3456 56.7826V57.4412C88.3456 59.6504 90.1364 61.4412 92.3456 61.4412H94.0878C96.2969 61.4412 98.0878 59.6504 98.0878 57.4412V56.7826C98.0878 54.5735 96.2969 52.7826 94.0878 52.7826Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7021 63.8372H41.9598C39.7507 63.8372 37.9598 65.628 37.9598 67.8372V68.4958C37.9598 70.7049 39.7507 72.4958 41.9598 72.4958H43.7021C45.9112 72.4958 47.7021 70.7049 47.7021 68.4958V67.8372C47.7021 65.628 45.9112 63.8372 43.7021 63.8372Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2939 63.8372H54.5517C52.3425 63.8372 50.5517 65.628 50.5517 67.8372V68.4958C50.5517 70.7049 52.3425 72.4958 54.5517 72.4958H56.2939C58.503 72.4958 60.2939 70.7049 60.2939 68.4958V67.8372C60.2939 65.628 58.503 63.8372 56.2939 63.8372Z",
    fill: "#E9F4F8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8949 63.8372H67.1527C64.9435 63.8372 63.1527 65.628 63.1527 67.8372V68.4958C63.1527 70.7049 64.9435 72.4958 67.1527 72.4958H68.8949C71.104 72.4958 72.8949 70.7049 72.8949 68.4958V67.8372C72.8949 65.628 71.104 63.8372 68.8949 63.8372Z",
    fill: "#DAEAF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.4868 63.8372H79.7445C77.5354 63.8372 75.7445 65.628 75.7445 67.8372V68.4958C75.7445 70.7049 77.5354 72.4958 79.7445 72.4958H81.4868C83.6959 72.4958 85.4868 70.7049 85.4868 68.4958V67.8372C85.4868 65.628 83.6959 63.8372 81.4868 63.8372Z",
    fill: "#DAEAF0"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 99,
    cy: 73,
    r: 12,
    fill: "#DEF0F7",
    stroke: "#E8F2F5",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.5 73L97.1464 75.6464C97.3417 75.8417 97.6583 75.8417 97.8536 75.6464L103.5 70",
    stroke: "#5CAA7F",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7454_55404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68.0383,
    height: 60,
    fill: "white",
    transform: "translate(34 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisitWhiteFang);
export default __webpack_public_path__ + "static/media/visit_white_fang.055490bbca533321fa5880465057f1df.svg";
export { ForwardRef as ReactComponent };